import { useState } from "react";
import { ContentProvider } from "@/context/ContentContext";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Packages } from "@/components/site/Packages";
import { Gallery } from "@/components/site/Gallery";
import { BookingSection } from "@/components/site/BookingSection";
import { Testimonials } from "@/components/site/Testimonials";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  const [selectedPackage, setSelectedPackage] = useState("");

  return (
    <ContentProvider>
      <div className="min-h-screen bg-[#FAF6F0]">
        <Navbar />
        <Hero />
        <Packages onSelectPackage={setSelectedPackage} />
        <Gallery />
        <BookingSection selectedPackage={selectedPackage} />
        <Testimonials />
        <About />
        <Contact />
        <Footer />
      </div>
    </ContentProvider>
  );
}
